'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface CategoryTabsProps {
  categories: Array<{
    id: string;
    name: string;
    icon: string;
    count: number;
  }>;
  activeCategory: string;
  onCategoryChange: (categoryId: string) => void;
}

const CategoryTabs = ({ categories, activeCategory, onCategoryChange }: CategoryTabsProps) => {
  return (
    <div data-component-id="src/app/resource-discovery-center/components/CategoryTabs.tsx:19:4" data-component-path="src/app/resource-discovery-center/components/CategoryTabs.tsx" data-component-line="19" data-component-end-line="45" data-component-file="CategoryTabs.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-card%20rounded-xl%20shadow-md%20p-4%20mb-6%20overflow-x-auto%22%7D" className="bg-card rounded-xl shadow-md p-4 mb-6 overflow-x-auto">
      <div data-component-id="src/app/resource-discovery-center/components/CategoryTabs.tsx:20:6" data-component-path="src/app/resource-discovery-center/components/CategoryTabs.tsx" data-component-line="20" data-component-end-line="44" data-component-file="CategoryTabs.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20gap-2%20min-w-max%20lg%3Amin-w-0%20lg%3Aflex-wrap%22%7D" className="flex gap-2 min-w-max lg:min-w-0 lg:flex-wrap">
        {categories.map((category) => (
          <button data-component-id="src/app/resource-discovery-center/components/CategoryTabs.tsx:22:10" data-component-path="src/app/resource-discovery-center/components/CategoryTabs.tsx" data-component-line="22" data-component-end-line="42" data-component-file="CategoryTabs.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
            key={category.id}
            onClick={() => onCategoryChange(category.id)}
            className={`flex items-center gap-2 px-4 py-2.5 rounded-lg font-semibold text-sm transition-all whitespace-nowrap ${
              activeCategory === category.id
                ? 'bg-primary text-primary-foreground shadow-md'
                : 'bg-muted text-foreground hover:bg-muted/80'
            }`}
          >
            <Icon data-component-id="src/app/resource-discovery-center/components/CategoryTabs.tsx:31:12" data-component-path="src/app/resource-discovery-center/components/CategoryTabs.tsx" data-component-line="31" data-component-end-line="31" data-component-file="CategoryTabs.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={category.icon as any} size={18} variant="outline" />
            <span data-component-id="src/app/resource-discovery-center/components/CategoryTabs.tsx:32:12" data-component-path="src/app/resource-discovery-center/components/CategoryTabs.tsx" data-component-line="32" data-component-end-line="32" data-component-file="CategoryTabs.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D">{category.name}</span>
            <span data-component-id="src/app/resource-discovery-center/components/CategoryTabs.tsx:33:12" data-component-path="src/app/resource-discovery-center/components/CategoryTabs.tsx" data-component-line="33" data-component-end-line="41" data-component-file="CategoryTabs.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
              className={`px-2 py-0.5 rounded-full text-xs font-bold ${
                activeCategory === category.id
                  ? 'bg-primary-foreground/20 text-primary-foreground'
                  : 'bg-background text-muted-foreground'
              }`}
            >
              {category.count}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryTabs;